/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfUserGroupDto } from '../../models/platform-api-result-of-user-group-dto';

export interface DeleteUsergroupsActionRemovepagefeatureId$Params {
  id: string;
}

export function deleteUsergroupsActionRemovepagefeatureId(http: HttpClient, rootUrl: string, params: DeleteUsergroupsActionRemovepagefeatureId$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfUserGroupDto>> {
  const rb = new RequestBuilder(rootUrl, deleteUsergroupsActionRemovepagefeatureId.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfUserGroupDto>;
    })
  );
}

deleteUsergroupsActionRemovepagefeatureId.PATH = '/api/usergroups/action/removepagefeature/{id}';
